import { render, staticRenderFns } from "./milestones-grid.vue?vue&type=template&id=2b01c7b3&scoped=true&"
import script from "./milestones-grid.vue?vue&type=script&lang=ts&"
export * from "./milestones-grid.vue?vue&type=script&lang=ts&"
import style0 from "./milestones-grid.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./milestones-grid.vue?vue&type=style&index=1&id=2b01c7b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01c7b3",
  null
  
)

export default component.exports